import styled from 'styled-components';

export const Icon = styled.button`
  flex: 1;
  background: none;
  border: 0;
  cursor: pointer;
`;
